var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotificationIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.384 10.995c0 1.57.415 2.496 1.328 3.562.692.786.913 1.794.913 2.888 0 1.093-.359 2.13-1.078 2.972a5.67 5.67 0 01-3.625 1.767c-1.965.167-3.93.308-5.921.308-1.993 0-3.957-.084-5.921-.308a5.664 5.664 0 01-3.625-1.767 4.52 4.52 0 01-1.08-2.972c0-1.094.222-2.102.913-2.888.942-1.066 1.33-1.992 1.33-3.562v-.532c0-2.103.524-3.477 1.603-4.823C9.826 3.677 12.4 2.5 14.945 2.5h.111c2.6 0 5.257 1.234 6.835 3.28 1.023 1.319 1.493 2.636 1.493 4.683v.532zM11.342 25.076c0-.63.578-.918 1.112-1.041.625-.132 4.433-.132 5.058 0 .534.123 1.111.412 1.111 1.041-.03.6-.382 1.13-.868 1.468a4.543 4.543 0 01-2.142.914 4.743 4.743 0 01-1.26 0 4.522 4.522 0 01-2.141-.915c-.487-.336-.839-.868-.87-1.467z",
    fill: "#BDBDBD"
  })));
}

export default SvgNotificationIcon;